import { observableMap } from '@wordpress/compose';
import { createContext } from '@wordpress/element';
import warning from '@wordpress/warning';
const initialValue = {
  slots: observableMap(),
  fills: observableMap(),
  registerSlot: () => {
    globalThis.SCRIPT_DEBUG === true ? warning('Components must be wrapped within `SlotFillProvider`. ' + 'See https://developer.wordpress.org/block-editor/components/slot-fill/') : void 0;
  },
  unregisterSlot: () => {},
  updateSlot: () => {},
  registerFill: () => {},
  unregisterFill: () => {},
  updateFill: () => {},
  // This helps the provider know if it's using the default context value or not.
  isDefault: true
};
const SlotFillContext = createContext(initialValue);
SlotFillContext.displayName = 'SlotFillContext';
export default SlotFillContext;